<template>
  <div>
    <div
      class="div-block-102 noselect"
    >
      <div class="refinancing-amount-summary">
        <span>Suma refinancovaných úverov</span>
        <strong>{{ amounts.suma_refinancovanie | dotTheAmount }} EUR</strong>
        <small>Mení sa automaticky podľa úverov vybraných nižšie.</small>
      </div>
      <div class="input-block contrast p-relative" v-for="(debt, key) in refinancedDebtsGetter" :key="key">
        <div class="closebtn-broker-app pointer" @click="remove(debt)">
          <img class="nav-link-icon extrasmall white" src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f24_icons8-close.svg"/>
        </div>
        <div class="closebtn-broker-app pointer edit" style="right: 20px;" @click="finishDebt(debt)">
          <img class="nav-link-icon extrasmall white" src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/64cb50251cbbf5e263940bb6_edit%20icon%20simple.svg"/>
        </div>
        <div class="div-block-101">
          <div>
            {{ translateDebtType(debt.typ) }} <strong>{{ translateBank(debt.banka) }}</strong>
          </div>
          <div class="bold">{{ debtBalance(debt) | dotTheAmount }} EUR</div>
        </div>
      </div>
      <client-debt-handler :type="'refinancovane'" :rules="['priority']" :title="'+ refinancovaný úver'"/>
    </div>
  </div>
</template>

<script>
import ClientDebtHandler from "../../../../shared/PopupHandler/Popups/ClientDebt/ClientDebtHandler";
import { mapGetters } from "vuex";
import translateFromDBValue from "../../../../../mixins/translateFromDBValue";
import clientFilters from "../../../../../mixins/clientFilters";

export default {
  name: "RefinancovanieWrapper",
  components: {ClientDebtHandler},
  props: {
    mortgage: Object,
    totalLimit: Number,
    loanPurpose: [String, null],
    clientsInfo: Object
  },
  mixins: [
    translateFromDBValue,
    clientFilters
  ],
  computed: {
    refinancedDebtsGetter () {
      return this.$store.getters["mortgageDetailState/getRefinancedDebts"](this.mortgageId);
    },
    ...mapGetters({
      amountsGetter: "mortgageDetailState/getAmounts",
      mortgageGetter: "mortgageDetailState/getMortgage",
    }),
  },
  data: () => ({
    amounts: null,
    limit: 0,
    refinancovanieDebtsAmount: 0,
    mortgageId: null,
  }),
  created () {
    this.mortgageId = parseInt(this.$route.params.hypoteka);
    this.amounts = this.$store.getters["mortgageDetailState/getAmounts"];
    const debts = this.$store.getters["mortgageDetailState/getRefinancedDebts"](this.mortgageId);
    this.syncRefinancovanieFromDebts(debts);
    if (!this.totalLimit) return;
    this.setMaximumAmount();
  },
  watch: {
    refinancedDebtsGetter: {
      handler (debts) {
        this.syncRefinancovanieFromDebts(debts);
      },
      deep: true,
    },
    // limit (newLimit) {
    //   this.$store.commit("mortgageDetailState/setAmountsLimits", {type: "suma_refinancovanie", value: newLimit});
    // },
    amountsGetter (newAmounts) {
      this.amounts = newAmounts;
      this.setMaximumAmount();
    },
    totalLimit () {
      this.setMaximumAmount();
    },
  },
  methods: {
    getRefinancedDebtsAmount (debts) {
      if (!Array.isArray(debts)) return 0;
      return debts.reduce((total, debt) => {
        return total + this.debtBalance(debt);
      }, 0);
    },
    debtBalance (debt) {
      const rawValue = debt?.zostatok?.value
        ?? debt?.zostatok
        ?? debt?.limit?.value
        ?? debt?.limit
        ?? debt?.balance
        ?? debt?.dti?.value
        ?? 0;
      return Math.abs(Number(rawValue || 0));
    },
    syncRefinancovanieFromDebts (debts) {
      const nextAmount = Math.round(this.getRefinancedDebtsAmount(debts));
      this.refinancovanieDebtsAmount = nextAmount;
      if (this.totalLimit) this.setMaximumAmount();
      if (!this.amounts || this.amounts.suma_refinancovanie === nextAmount) return;
      this.setRefinancovanieAmount(nextAmount);
    },
    finishDebt (debt) {
      const clientInfo = Object.values(this.clientsInfo).find((clientInfo) => clientInfo.id === debt.klient);
      this.$store.commit("popupManagerState/setClientInfo", clientInfo);
      this.$store.commit("popupManagerState/pushToPopupOrder", {
        type: {debtType: debt.typ, debtPurpose: "classic"},
        payload: debt,
        component: "ClientDebtPopUp",
        rules: null,
      });
    },
    remove (debt) {
      const clientObject = this.getClientType(debt.klient);
      const debtObject = {
        id: debt.id,
        plan: "repay",
        clientRole: clientObject.type_code,
        clientLabel: clientObject.type,
      };
      this.$store.dispatch("mortgageDetailState/setMortgageDebtPlan", debtObject);
    },
    translateTypeFromDBValue (type) {
      switch (type) {
        case "hypoteka":
          return "Hypotéka";
        case "povolene_precerpanie":
          return "Povolené prečerpanie";
        case "kreditna_karta":
          return "Kreditná karta";
        case "spotrebny_uver":
          return "Spotrebný úver";
        case "leasing":
          return "Leasing";
      }
    },
    setMaximumAmount () {
      let limit = this.totalLimit;
      for (const [key, amount] of Object.entries(this.amounts)) {
        if (key === "suma_refinancovanie") continue;
        limit = limit - amount;
      }
      this.limit = Math.max(0, limit, this.refinancovanieDebtsAmount);
    },
    async setRefinancovanieAmount (value) {
      value = Math.round(Number(value || 0));
      if (value !== this.refinancovanieDebtsAmount) {
        value = this.refinancovanieDebtsAmount;
      }
      if (this.amounts.suma_refinancovanie === value) return;
      this.$store.commit("mortgageDetailState/setAmount", {
        type: "suma_refinancovanie",
        value
      });
      const mortgageObject = this.createObjectToHistory();
      this.$store.dispatch("mortgageDetailState/patchMortgage", mortgageObject);
      this.$store.dispatch("mortgageDetailState/fetchOffers", this.mortgage.id);
    },
    createObjectToHistory () {
      const currentHistory = this.mortgage.offers_filter_history;
      const applicationData = this.$store.getters["mortgageDetailState/getOffersData"];
      const amounts = this.$store.getters["mortgageDetailState/getAmounts"];
      let newHistoryObject = {
        date: new Date().toISOString(),
        fix: applicationData.fix ? applicationData.fix : 3,
        suma_bezucel: amounts.suma_bezucel ? amounts.suma_bezucel : 0,
        suma_nadobudnutie: amounts.suma_nadobudnutie ? amounts.suma_nadobudnutie : 0,
        suma_refinancovanie: amounts.suma_refinancovanie ? amounts.suma_refinancovanie : 0
      };
      if (!currentHistory) {
        return {
          id: this.mortgage.id,
          object: {
            offers_filter_history: {
              broker: {
                lastOffersSetup: null,
                history: [newHistoryObject],
              },
              sent: [],
              client: [],
            }
          },
        }
      } else {
        return {
          id: this.mortgage.id,
          object: {
            offers_filter_history: {
              sent: currentHistory.sent,
              client: currentHistory.client,
              broker: {
                lastOffersSetup: currentHistory.broker?.lastOffersSetup ? currentHistory.broker.lastOffersSetup : null,
                history:
                  currentHistory.broker.history ? [newHistoryObject, ...currentHistory.broker.history] : Array.isArray(currentHistory.broker) && currentHistory.broker?.length !== 0 ? [newHistoryObject, ...currentHistory.broker] : [newHistoryObject],
              }
            }
          }
        }
      }
    },
  }
};
</script>

<style scoped>
.refinancing-amount-summary {
  display: flex;
  width: 100%;
  margin-bottom: 20px;
  padding: 13px 15px;
  flex-direction: column;
  gap: 3px;
  box-sizing: border-box;
  border: 1px solid var(--app-border);
  border-radius: 12px;
  background: var(--app-surface-muted);
}

.refinancing-amount-summary span,
.refinancing-amount-summary small {
  color: var(--app-text-muted);
}

.refinancing-amount-summary span {
  font-size: 10px;
}

.refinancing-amount-summary strong {
  color: var(--app-text);
  font-size: 15px;
}

.refinancing-amount-summary small {
  font-size: 9px;
  line-height: 1.4;
}
</style>
